import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image33 from "../../../../assets/images/Blog65/image33.png";
import image37 from "../../../../assets/images/Blog65/image37.png";
import image45 from "../../../../assets/images/Blog65/image45.png";
import image40 from "../../../../assets/images/Blog65/image40.png";
import image27 from "../../../../assets/images/Blog65/image27.png";
import image6 from "../../../../assets/images/Blog65/image6.png";
import image7 from "../../../../assets/images/Blog65/image7.png";
import image8 from "../../../../assets/images/Blog65/image8.png";
import image9 from "../../../../assets/images/Blog65/image9.png";
import image16 from "../../../../assets/images/Blog65/image16.png";
import image18 from "../../../../assets/images/Blog65/image18.png";
import image50 from "../../../../assets/images/Blog65/image50.png";
import image54 from "../../../../assets/images/Blog65/image54.png";
import image70 from "../../../../assets/images/Blog65/image70.png";
import image53 from "../../../../assets/images/Blog65/image53.png";
import image19 from "../../../../assets/images/Blog65/image19a.png";
import image72 from "../../../../assets/images/Blog65/image72.png";

const Blog65 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – April 20, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Risk-On Momentum Extends, Positioning Builds Beneath the Surface</p>
        <p>
          Markets enter the week with a constructive tone, as risk assets continue to grind higher despite a volatile geopolitical backdrop. Price action reflects a market increasingly willing to look
          through uncertainty, with participation broadening and flows reinforcing upside momentum rather than fading it.
        </p>
        <p>
          Geopolitics continues to shift rapidly between escalation and resolution, but the market is increasingly choosing to focus on outcomes rather than headlines. Beneath this strength, however,
          positioning is becoming increasingly stretched. Liquidity remains supportive, and systematic flows continue to drive price, but the move is increasingly being driven by flows rather than
          fresh conviction, leaving the market sensitive to shifts in narrative.
        </p>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Broad Participation Supporting a Strong Advance</p>
              <p>
                Equity markets have pushed higher with increasing consistency, supported by improved sentiment, stronger earnings signals, and easing geopolitical concerns. The structure of the rally
                suggests a market that is not purely driven by narrow leadership, but instead supported by broader participation across sectors and market caps.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="NAS100 streak1"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Momentum has been particularly evident in growth-heavy indices, with extended winning streaks reflecting persistent buying pressure. At the same time, the consistency of gains across
                multiple indices highlights a market where flows are actively reinforcing price action rather than fading it.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt="consecutive weekly SPX gains over 3%"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                This type of environment typically reflects strong systematic and liquidity-driven participation. The steady climb higher, rather than sharp impulsive moves, suggests that flows remain
                in control, with systematic flows continuing to dominate price action
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt="SPX breadth"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Breadth metrics confirm this dynamic, with a significant proportion of stocks trading above key moving averages and new highs consistently outpacing new lows. This reinforces the idea
                that the advance is not fragile in structure, but supported by widespread participation.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt="weekly sector performance"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Sector performance further supports this view, with gains extending beyond mega-cap technology into broader cyclical and mid-cap exposures, suggesting participation is broadening
                beyond mega-cap leadership.
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Growth Resilience and Liquidity Support</p>
              <p>
                The macro backdrop continues to be defined by the interaction between geopolitics, growth resilience, and liquidity conditions. While geopolitical developments remain active, the
                market has largely priced out the risk of a sustained escalation, allowing focus to shift back toward underlying economic trends.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt="GS oil normalising Mid-May still"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Energy markets have begun to reflect a more balanced outlook, with the reopening of flows removing one of the key overhangs on risk assets that had previously tightened financial
                conditions. This shift has supported broader risk sentiment and eased concerns around sustained supply shocks.
              </p>
              <p>
                At the same time, growth indicators have shown resilience, with demand-related data holding up better than expected. This has contributed to a reassessment of downside risks and
                supported the continuation of the rally.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="Truck demand positive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="truck diffusion positive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Inflation dynamics remain uneven, with certain components continuing to show persistence despite broader expectations of moderation.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt="fertiliser prices lead food spikes"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="car repairs an issue for CPI"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                This reinforces the risk that rates may struggle to come down as quickly as expected. Liquidity conditions continue to act as a key support, with strong demand across fixed income
                markets and sustained participation in credit.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt="record bond demand"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="Banks season not seeing private credit time bomb"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>The combination of resilient growth and supportive liquidity continues to underpin risk assets, even as policy expectations remain somewhat uncertain.</p>
              <p>As has been the case throughout, growth continues to trump everything</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                The broader technical structure remains supportive, with price trends continuing to move higher across major indices. However, the pace and consistency of the advance are beginning to
                push sentiment toward more extended levels.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="Russell breadth"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Breadth remains strong, reinforcing the durability of the move, but also highlighting how far participation has expanded over a relatively short period. This type of broad strength
                often supports continuation, but can also reduce the margin for error.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image54}
                    alt="put call ratio now at short term complacency extremes"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image54)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Positioning indicators suggest a shift toward increasingly bullish sentiment, with options activity reflecting a growing consensus around continued upside. This type of positioning can
                support momentum in the near term, but also introduces vulnerability to any change in narrative.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image70}
                    alt="VIX volatility being crushed"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image70)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Volatility has compressed significantly, reflecting reduced demand for hedging and a market that is increasingly comfortable with current conditions. While this supports trend
                continuation, it also reflects a degree of complacency that can amplify reactions to unexpected developments.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image53}
                    alt="confirmation of buy the dip flows last week"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image53)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Flow data further reinforces the strength of the current environment, with consistent inflows supporting the “buy-the-dip” dynamic that has defined recent price action.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Momentum Builds as Risk Perception Eases</p>
              <p>
                The past week reflected a continuation of the constructive trend, with improving sentiment and supportive flows driving consistent gains across risk assets. The pricing out of
                geopolitical risk allowed markets to focus on underlying strength, reinforcing the upward move.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br />
                    Growth-related indicators continued to show resilience, with demand holding up and concerns around immediate slowdown easing. At the same time, inflation components remained
                    uneven, highlighting ongoing pressure in specific areas.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image6}
                        alt="Truck demand positive"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image6)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br />
                    Positioning and broader flows reflected continued adjustments in global asset allocation, with ongoing shifts in holdings occurring in a gradual and controlled manner.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image19}
                        alt="US Treasury concerns over done for China"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image19)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br />
                    Early signals from earnings season indicated a shift toward more positive outcomes, with markets responding to improving expectations and reduced downside surprises.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br />
                    Commodity dynamics reflected a more balanced outlook, with energy normalisation and continued structural support in other areas contributing to a mixed but stabilising environment.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image27}
                        alt="GS oil normalising Mid-May still"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image27)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image8}
                        alt="fertiliser prices lead food spikes"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image8)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br />
                    Speculative positioning has remained concentrated in high-beta equity exposure, particularly within Nasdaq-linked flows
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image33}
                        alt="NAS100 streak1"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image33)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image53}
                        alt="confirmation of buy the dip flows last week"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image53)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br />
                    Oil markets moved away from extreme pricing scenarios, with expectations shifting toward normalisation as supply concerns eased.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image27}
                        alt="GS oil normalising Mid-May still"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image27)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week is driven by a dense macro calendar alongside ongoing geopolitical developments, with a focus on central bank direction, inflation signals, global PMIs, and a heavy earnings
                slate, particularly across financials and technology.
              </p>

              <p className="highlightedText">Monday, April 20</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> House Price Index (Rightmove)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Loan Prime Rate decisions (PBoC)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> PPI (MoM, YoY)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> CPI (Core, Median, Trimmed)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Construction Output
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 3-month & 6-month Bill Auctions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">ECB:</span> President Lagarde speaks
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, April 21</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Employment data, wages, unemployment rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU / Germany:</span> ZEW Economic Sentiment & Conditions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Retail Sales (Core, Control Group, YoY)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Business Inventories & Housing Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Warsh Fed Chair Confirmation Hearing
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Fed / ECB speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, April 22</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> CPI, Core CPI, PPI, RPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Government Debt & Budget metrics
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Mortgage Applications & Rates
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 20-Year Bond Auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Tesla, IBM
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, April 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> Manufacturing & Services PMIs (US, EU, UK, Japan, India)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Initial & Continuing Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Chicago Fed Activity Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Fed Balance Sheet & Reserve Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> KC Fed Manufacturing Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Intel, SAP
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, April 24</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> National CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> Ifo Business Climate & Expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Michigan Consumer Sentiment & Inflation Expectations
                  </p>
                </li>
              </ul>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image72}
                    alt="EW200426"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image72)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Momentum Supported, but Positioning Extended</p>
              <p>The market continues to be supported by a combination of resilient growth, easing macro concerns, and strong liquidity conditions, allowing risk assets to extend their advance.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br />
                    Structure remains constructive with broad participation and consistent inflows supporting price action, though the pace of gains suggests positioning is becoming more extended.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span>
                    <br />
                    Precious metals continue to reflect broader liquidity dynamics, with price behaviour acting more as a liquidity indicator than a direct geopolitical hedge.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br />
                    Momentum-driven participation remains strong, reflecting broader risk appetite and continued flow-based support.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro:</span>
                    <br />
                    The interaction between growth resilience, inflation persistence, and policy expectations remains central, with liquidity continuing to act as the primary support for markets.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">
                The environment remains supportive, but increasingly dependent on the continuation of current conditions. A shift in narrative or positioning could lead to more reactive price
                behaviour despite the underlying strength.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image54}
                    alt="put call ratio now at short term complacency extremes"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image54)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image70}
                    alt="VIX volatility being crushed"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image70)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="Russell breadth"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1EvUTH3Xc0AxgpBF0RSUcCABH4ubQ2sh5DTJNkKmr_KE/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog65;
